// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mapdialog{width:79.167vw!important}.mapdialog .el-dialog__header{width:78.906vw!important}.mapdialog .el-dialog__body{width:78.906vw!important;height:27.083vw!important}", ""]);
// Exports
module.exports = exports;
